export enum SignupErrorTypes {
  EmailTaken = 'email-taken',
  Unknown = 'unknown',
}
